import { DirectiveType } from '../../types';
import { AbstractMultiValueDirective } from '../abstract-multi-value-directive';
export class MediaSource extends AbstractMultiValueDirective {
    getDirectiveName() {
        return 'media-src';
    }
    getDirectiveType() {
        return DirectiveType.Fetch;
    }
}
